import type { Ref } from 'react';
import cn from 'classnames';
import { DatePickerCalendar, DatePickerInput, DatePickerPopover, DateRangePicker } from '@finn-no/troika-react-datepicker';

import { useWindowSize } from '@/utils/WindowSizeProvider';
import { isNotWithinOneYearOfToday, safeToDate } from 'shared/util/datetime-fns';

import { InputErrors } from '@/components/inputErrors/InputErrors';

import '@finn-no/troika-react-datepicker/dist/style.css';

export interface CheckInCheckOutCalendarProps {
    checkInDate?: Date | number;
    checkOutDate?: Date | number;
    setCheckInDate: (date: Date | number) => void;
    setCheckOutDate: (date: Date | number) => void;
    errors?: readonly string[];
    isInvalid?: boolean;
    checkinDateRef?: Ref<HTMLInputElement>;
}

export const CheckInCheckOutCalendar = ({
    checkInDate,
    checkOutDate,
    setCheckInDate,
    setCheckOutDate,
    errors = [],
    isInvalid,
    checkinDateRef,
}: CheckInCheckOutCalendarProps) => {
    const { isMobile } = useWindowSize();
    const numberOfMonths = isMobile ? 1 : 2;
    return (
        <div
            className={cn('grid input input--date u-valign-top', {
                'input--is-invalid': errors.length > 0 || isInvalid,
            })}
            data-testid="CheckInCheckOutCalendar">
            <DateRangePicker
                startDate={safeToDate(checkInDate)}
                endDate={safeToDate(checkOutDate)}
                minimumNights={1}
                onChange={({ startDate, endDate }) => {
                    setCheckInDate(startDate?.getTime());
                    setCheckOutDate(endDate?.getTime());
                }}
                isDayDisabled={isNotWithinOneYearOfToday}>
                <div className="date-range-label-wrap">
                    <label htmlFor="date-range-start" className="u-size1of2">
                        Dato innsjekk
                    </label>
                    <label htmlFor="date-range-end" className="u-size1of2 u-pl8">
                        Dato utsjekk
                    </label>
                </div>
                <div className="u-position-relative calendar-flex">
                    <div className="u-display-inline-block u-size1of2">
                        <DatePickerInput
                            dateField="startDate"
                            as="input"
                            id="date-range-start"
                            ref={checkinDateRef}
                            placeholder="Velg dato"
                        />
                    </div>
                    <div className="u-display-inline-block u-size1of2">
                        <DatePickerInput dateField="endDate" as="input" id="date-range-end" placeholder="Velg dato" />
                    </div>
                </div>
                <DatePickerPopover className="date-popover">
                    <DatePickerCalendar numberOfMonths={numberOfMonths} />
                </DatePickerPopover>
            </DateRangePicker>
            <InputErrors errors={errors} />
        </div>
    );
};
